<template>
  <div class="hab-modal">
    <div class="hab-modal__box">
      <div class="hab-modal__title">{{ title }}</div>
      <div class="hab-modal__content">
        <p>{{ content }}</p>
      </div>
      <div class="hab-modal__footer">
        <div class="hab-modal__footer__item">
          <span @click="$emit('close')">{{ $t('book.back') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
  },
  emits: ['close']
};
</script>
